import { useEffect } from 'react';
import { useAuthStore } from '@/stores/auth';

// Refresh auth state whenever the tab regains focus. This picks up any
// status changes that happened server-side while the user was away
// (e.g. the test-phase cron banning them, or an admin flip). Route
// guards then redirect as needed.
export function useAuthFocusRefresh(): void {
  const refreshAuth = useAuthStore((s) => s.refreshAuth);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;
    const handler = (): void => {
      void refreshAuth();
    };
    window.addEventListener('focus', handler);
    return () => window.removeEventListener('focus', handler);
  }, [isAuthenticated, refreshAuth]);
}
